import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IPendingOrder,
  IProductOrderDetails,
  ICancelOrder,
  IPortfolioOrderDetails
} from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/transactions`
});

export function getPendingOrders(type: string): Promise<IPendingOrder> {
  return http.get(`/v1/orders/${type}`);
}

export function getProductOrderDetails(
  orderId: string,
  productType: string
): Promise<IProductOrderDetails> {
  return http.get(`/v1/shelf-orders/${orderId}/details`, {
    params: {
      productType
    }
  });
}

export function getPortfolioOrderDetails(
  orderId: string,
  productType: string
): Promise<IPortfolioOrderDetails> {
  return http.get(`/v1/portfolio-orders/${orderId}/details`, {
    params: {
      productType
    }
  });
}

export function cancelOrder(orderId: string): Promise<ICancelOrder> {
  return http.put('/v1/orders/cancel', { orderId });
}
